import React, { useEffect, useState, useRef } from 'react';
import {
    Row, Col, Button, ProTableOt, useProTableOt, setParamsFilter, Input, Form, AspectRatio,
    Accordion, AccordionItem, AccordionTrigger, AccordionContent, Tabs,
    Typography, Badge
} from '../../ui/ot'
import { useSearchParams, useNavigate } from "react-router-dom";
import { useCRUDController } from "../../ui/classify_structure/CRUDController";
import AdvancedSearchForm from './advanced_search_form'
import useWindowSize from '../controllers/window_size';
import { useBib } from '../../koha/controllers/bib_controller';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "../../ui/card"
import { Checkbox } from "../../ui/checkbox"
import { Label } from "../../ui/label"
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "../../ui/select";
import dayjs from 'dayjs';
import { useTranslation } from "react-i18next";
import { Search, Filter, BookOpen, FileText, Film, BookMarked, X, ArrowUpDown } from "lucide-react"
// import { Slider } from "../../ui/slider"
function SearchFunction({
    keyPrefix = "library.online_public_catalog_query_construction.collection_search"
}) {
    const navigate = useNavigate();
    const { t } = useTranslation('translation', { keyPrefix })

    const [advancedSearch, setAdvancedSearch] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const { width, height } = useWindowSize();
    const [selectedSearch, setSelectedSearch] = useState(null); // 館藏區選擇
    const [tableSearchParams, setTableSearchParams] = useState({
        branchcode_arr: [],
        ...Object.fromEntries(searchParams.entries()),
    });
    const [showMode, setShowMode] = useState("cardPage")
    const styles = {
        searchContainer: {
            margin: '20px',
            justifyContent: 'center',
            alignItems: 'center',
        },
        selectStyle: {
            backgroundColor: 'white',
            border: '2px solid #2f7c9d',
            color: '#2f7c9d',
            borderRadius: '50px',
            width: '100%',
            textAlign: 'center',
            padding: '5px',
        },
        searchInput: {
            borderRadius: '50px',
            border: '2px solid #2f7c9d',
            padding: '5px 20px',
            width: '100%',
        },
        searchButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '100%',
        },
        informationButton: {
            backgroundColor: '#f28d35',
            border: 'none',
            borderRadius: '50px',
            padding: '5px 20px',
            color: 'white',
            width: '20%',
        },
        cardStyle: {
            marginTop: '20px',
            border: '1px solid #eaeaea',
            borderRadius: '10px',
            padding: '15px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        },
        titleStyle: {
            fontSize: '1.2rem', // 調整字體大小
            fontWeight: 'bold', // 設置粗體
        },
        imageStyle: {
            width: 'auto',
            // height: 'auto',
            height: "14em",
            // width: "14em",
        },
        paginationButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #2f7c9d',
            borderRadius: '5px',
            cursor: 'pointer',
        },
        disabledButton: {
            margin: '5px',
            padding: '5px 10px',
            border: '1px solid #ccc',
            borderRadius: '5px',
            cursor: 'not-allowed',
            color: '#ccc',
        },
        activeButton: {
            backgroundColor: '#2f7c9d',
            color: 'white',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        inactiveButton: {
            backgroundColor: 'white',
            color: '#2f7c9d',
            border: '2px solid #2f7c9d',
            borderRadius: '20px',
            width: '100%',
            margin: '5px 0',
        },
        sectionTitle: {
            fontSize: '18px',
            fontWeight: 'bold',
        },
        buttonGroup: {
            margin: '5px 0',
        }
    };
    const [advanced_search_form] = Form.useForm(); //form 
    const [form] = Form.useForm(); //form 

    const actionRef = useRef(null); //要呼叫ProTableOt 的 function 所需要的，想知道原理請去查詢 forwardRef, useImperativeHandle, 
    const columns = [
        {
            title: `${t('bib_title')}`,
            dataIndex: "bib_title",
            key: "bib_title",
            width: "400px"
        },
        {
            title: `${t('import_bibliography_date')}`,
            dataIndex: "bib_datecreated",
            key: "bib_datecreated",
        },
        {
            title: `${t('Author')}`,
            dataIndex: "bib_author",
            key: "bib_author",
        },
        {
            title: `${t('bib_translator')}`,
            dataIndex: "bib_translator",
            key: "bib_translator",
        },

        {
            title: `${t('Material_type')}`,
            dataIndex: "bib_materialType",
            key: "bib_materialType",
        },
        {
            title: `${t('Series')}`,
            dataIndex: "bib_seriestitle",
            key: "bib_seriestitle",
            render: (text, record, index) => {
                return <>{record?.bib_seriestitle} {record?.bibitem_volume}</>
            }
        },
        {
            title: `${t('Publication_details')}`,
            dataIndex: "bib_publisher",
            key: "bib_publisher",
        },
        {
            title: `${t('Description')}`,
            dataIndex: "bib_notes",
            key: "bib_notes",
        },
        {
            title: `${t('ISBN')}`,
            dataIndex: "bibitem_isbn",
            key: "bibitem_isbn",
        },
        {
            title: `${t('Edition')}`,
            dataIndex: "bibitem_editionstatement",
            key: "bibitem_editionstatement",
        },
        {
            title: `${t('Other_title')}`,
            dataIndex: "bib_othertitle",
            key: "bib_othertitle",
            render: (text, record, index) => {
                return <>{text?.join('、')}</>
            }
        },
        {
            title: ``,
            dataIndex: "bibitem_editionstatement",
            key: "bibitem_editionstatement",
            render: (text, record, index) => {
                return (<Button
                // style={styles.informationButton}
                onClick={() => {
                    window.open(`./collection_search/?biblionumber=${record?.bib_biblionumber}`, 'blank')
                }}
            >
                館藏資訊
            </Button>)
            }
        },

    ];
    const keyLabelMap = {
        bib_language: "語言",
        bib_author: "作者",
        bib_othertitle: "其他書名",
        bib_seriestitle: "叢書系列",
        bibitem_itemtype_description: "館藏分類",
        home_branch: "館藏地"
    };


    const [postCoordinateSearching, setPostCoordinateSearching] = useState(null)
    const handleCollectionClick = (value) => {
        setTableSearchParams((pre) => {
            let preBranchcodeArr = [...pre?.branchcode_arr]
            if (preBranchcodeArr.includes(value)) {
                preBranchcodeArr = preBranchcodeArr.filter((ele) => ele !== value)
                return {
                    ...pre,
                    branchcode_arr: [...preBranchcodeArr]
                }
            }
            else {
                return {
                    ...pre,
                    branchcode_arr: [...preBranchcodeArr, value]
                }
            }

        })
    };


    const onSubmit = (values) => {

        setTableSearchParams((pre) => {
            return {
                keyword: values?.keyword,
                field: values?.field,
                branchcode_arr: pre?.branchcode_arr,
            }
        })
        // navigate(`${propsNavigateSearchPath}?` + new URLSearchParams(values));
    };

    const bibController = useCRUDController({
        apiRoute: "/koha/bib",
    })
    const libraryController = useCRUDController({
        apiRoute: "/koha/library",
        // onBefore: ()=>{},
        // onFinish: onFinish,
    })
    const { check, setCheck, checkAll, setOrders, custom_filter_key } =
        useProTableOt({
            columns,
        });
    const {
        BibData,
        getBibData,
        getBibInfoFormat
    } = useBib({
        onFinish: () => { },
        onBefore: () => { }
    })
    useEffect(() => {
        checkAll();
        libraryController.getData({})
    }, []);
    useEffect(() => {
        let searchValue = { ...Object.fromEntries(searchParams.entries()) }
        form.setFieldsValue({ ...searchValue })
        if (!!searchValue?.operator2) {
            setAdvancedSearch(true)
        }
        advanced_search_form.setFieldsValue({
            search: [
                {
                    operator: searchValue?.operator,
                    field: searchValue?.field,
                    keyword: searchValue?.keyword,
                },
                {
                    operator: searchValue?.operator2,
                    field: searchValue?.field2,
                    keyword: searchValue?.keyword2,
                },
                {
                    operator: searchValue?.operator3,
                    field: searchValue?.field3,
                    keyword: searchValue?.keyword3,
                },
            ]
        })
    }, [searchParams])
    useEffect(() => {
        actionRef.current.reloadAndRest()
    }, [tableSearchParams])
    useEffect(() => {
        if (width <= 430) {
            setShowMode('card')
        }
        else {
            setShowMode('cardPage')
        }
    }, [width])
    useEffect(() => {
        if (showMode === "card") {
            actionRef.current.reloadAndRest()
        }
        else {
            actionRef.current.reload()
        }
    }, [showMode])
    return (
        <div style={styles.searchContainer}>
            <Col span={24}>
                <Row justify="center">
                    <Col xxl={18} xl={18} lg={20} md={24} sm={24} xs={24}>
                        <Form
                            form={form}
                            onValuesChange={() => { }}
                            onFinish={onSubmit}
                            autoComplete="off"
                            initialValues={{
                                type: "0"
                            }}
                        >
                            <Row justify="center" align={"middle"} gutter={[8, 8]}>
                                <Col xxl={3} xl={3} lg={4} md={4} sm={4} xs={8}  >

                                </Col>
                                <Col xxl={15} xl={15} lg={16} md={16} sm={24} xs={22} >
                                    <Form.Item
                                        name={"keyword"}
                                        rules={[
                                            {
                                                required: true,
                                                message: "請輸入",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder="搜尋館藏"
                                            className="inputBorder"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col xxl={6} xl={6} lg={4} md={4} sm={24} xs={24} >
                                    <Row gutter={[8, 16]} justify="center">
                                        <Col>
                                            <Button
                                                type="button"
                                                className=" h-10 px-4 rounded-full"
                                                style={{ fontSize: "1.6em", height: "90%" }}

                                                onClick={() => {
                                                    setSelectedSearch(null)
                                                    if (!!advancedSearch) {
                                                        advanced_search_form.submit()
                                                    }
                                                    else {
                                                        form.submit()
                                                    }

                                                }}
                                            >
                                                查詢
                                            </Button>
                                        </Col>
                                        <Col >
                                            <Button
                                                type="button"
                                                className=" h-10 px-4 rounded-full"
                                                style={{ fontSize: "1.6em", height: "90%" }}
                                                onClick={() => {
                                                    setAdvancedSearch((pre) => {
                                                        if (!!pre) {
                                                            advanced_search_form.setFieldsValue({
                                                                search: [
                                                                    {
                                                                        field: "keyword",
                                                                        keyword: null
                                                                    }
                                                                ]
                                                            })
                                                        }

                                                        return !pre
                                                    })

                                                }}
                                            >
                                                {advancedSearch ? "一般查詢" : "進階查詢"}
                                            </Button>
                                        </Col>
                                        <Col span={24}>
                                        </Col>
                                    </Row>

                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    {advancedSearch && <Col span={24}>
                        <Row justify="center">
                            <Col xxl={20} xl={20} lg={20} md={22} sm={24} xs={24}>
                                <AdvancedSearchForm
                                    propsForm={advanced_search_form}
                                    onFormFinish={(formValue) => {
                                        let { search } = formValue
                                        let values = {}
                                        search?.forEach((element, index) => {
                                            if (!!index) {
                                                values[`field${index + 1}`] = element?.field
                                                values[`keyword${index + 1}`] = element?.keyword
                                                values[`operator${index + 1}`] = element?.operator
                                            }
                                            else {
                                                values[`field`] = element?.field
                                                values[`keyword`] = element?.keyword
                                            }
                                        });
                                        setTableSearchParams((pre) => {
                                            return {
                                                ...values,
                                                branchcode_arr: pre?.branchcode_arr,
                                            }
                                        })
                                        // navigate(`${propsNavigateSearchPath}?` + new URLSearchParams(values));
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>}

                </Row>
            </Col>
            <Row>
                <Col span={24}>
                    <Row gutter={[16, 16]}>
                        <Col xxl={4} xl={4} lg={4} md={8} sm={8} xs={24}>
                            <Accordion defaultValue={width <= 430 ? null : "show"} type="single" collapsible>
                                <AccordionItem value={"show"}>
                                    <AccordionTrigger><p style={{ fontSize: '25px', fontWeight: 'bold', paddingTop: '15px', paddingBottom: '10px' }}> 篩選</p></AccordionTrigger>
                                    <AccordionContent>
                                        <Row>
                                            {postCoordinateSearching &&
                                                <Col span={24}>
                                                    <div>
                                                        <Card className="border-library-200 shadow-sm sticky top-4">
                                                            <CardHeader className="bg-gradient-to-r from-library-50 to-library-100 rounded-t-lg">
                                                                <div className="flex justify-between items-center">
                                                                    <Button
                                                                        onClick={() => {
                                                                            actionRef.current.reloadAndRest()
                                                                        }}
                                                                        variant="ghost" size="sm"  >套用篩選</Button>
                                                                    <Button
                                                                        onClick={() => {
                                                                            setSelectedSearch(null)
                                                                        }}
                                                                        variant="ghost" size="sm" className="h-8 px-2 text-library-700 hover:bg-library-100">
                                                                        <X className="h-4 w-4 mr-1" />
                                                                        清除全部
                                                                    </Button>
                                                                </div>
                                                            </CardHeader>
                                                            <CardContent className="p-4">
                                                                <Accordion type="multiple" defaultValue={Object.keys(postCoordinateSearching)} className="space-y-2">
                                                                    {/* 特例處理：出版年份 */}
                                                                    {"bib_copyright_min_time" in postCoordinateSearching && "bib_copyright_max_time" in postCoordinateSearching && (
                                                                        <AccordionItem value="year" className="border-library-200">
                                                                            <AccordionTrigger className="text-library-800 hover:text-library-600 py-2">出版年份</AccordionTrigger>
                                                                            <AccordionContent>
                                                                                <div className="space-y-4 px-1">
                                                                                    <div className="flex justify-between text-sm text-library-700">
                                                                                        <span>{postCoordinateSearching?.bib_copyright_min_time}</span>
                                                                                        <span>{postCoordinateSearching?.bib_copyright_max_time}</span>
                                                                                    </div>
                                                                                    <div className="flex justify-between gap-2">
                                                                                        <Input
                                                                                            type="number"
                                                                                            placeholder="最小"
                                                                                            defaultValue={parseInt(postCoordinateSearching?.bib_copyright_min_time)}
                                                                                            className="w-full border-library-200"
                                                                                        />
                                                                                        <span className="flex items-center text-library-500">-</span>
                                                                                        <Input
                                                                                            type="number"
                                                                                            placeholder="最大"
                                                                                            defaultValue={parseInt(postCoordinateSearching?.bib_copyright_max_time)}
                                                                                            className="w-full border-library-200"
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </AccordionContent>
                                                                        </AccordionItem>
                                                                    )}

                                                                    {/* 一般資料 map 產生 */}
                                                                    {Object.entries(postCoordinateSearching).map(([key, value]) => {
                                                                        // 過濾掉非陣列 or 已經處理過的 key
                                                                        if (!Array.isArray(value) || key.startsWith("bib_copyright")) return null;

                                                                        const title = keyLabelMap[key] || key; // fallback title
                                                                        const idPrefix = key.replace(/[^a-zA-Z0-9]/g, ""); // clean ID base

                                                                        return (
                                                                            <AccordionItem key={key} value={key} className="border-library-200">
                                                                                <AccordionTrigger className="text-library-800 hover:text-library-600 py-2">{title}</AccordionTrigger>
                                                                                <AccordionContent>
                                                                                    <div className="grid gap-2 pl-1">
                                                                                        {value.map((item, index) => (
                                                                                            <div key={index} className="flex items-center space-x-2">
                                                                                                <Checkbox
                                                                                                    checked={selectedSearch?.[key] ? selectedSearch?.[key].includes(item?.item_name) : false}
                                                                                                    onCheckedChange={(checked) => {
                                                                                                        setSelectedSearch((pre) => {
                                                                                                            let old = { ...pre }
                                                                                                            if (checked) {
                                                                                                                let objArray = old?.[key] || []
                                                                                                                objArray.push(item?.item_name)
                                                                                                                return {
                                                                                                                    ...pre,
                                                                                                                    [key]: objArray
                                                                                                                }
                                                                                                            }
                                                                                                            else {
                                                                                                                let objArray = [...old[key]]
                                                                                                                objArray = objArray.filter((ele) => ele !== item?.item_name)
                                                                                                                return {
                                                                                                                    ...pre,
                                                                                                                    [key]: objArray
                                                                                                                }
                                                                                                            }
                                                                                                        })
                                                                                                    }}
                                                                                                    id={`${idPrefix}-${index}`} className="border-library-300" />
                                                                                                <Label htmlFor={`${idPrefix}-${index}`} className="flex items-center text-sm font-normal cursor-pointer">
                                                                                                    {item?.item_name}
                                                                                                    <Badge className="ml-2 bg-library-100 text-library-700 hover:bg-library-200">{item?.item_value}</Badge>
                                                                                                </Label>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                </AccordionContent>
                                                                            </AccordionItem>
                                                                        );
                                                                    })}
                                                                </Accordion>
                                                            </CardContent>

                                                        </Card>
                                                    </div>
                                                </Col>}
                                        </Row>
                                    </AccordionContent>
                                </AccordionItem>
                            </Accordion>
                        </Col>

                        <Col xxl={20} xl={20} lg={20} md={16} sm={16} xs={24}>
                            <Row>
                                <Col span={24}>
                                    <Tabs
                                        items={[
                                            {
                                                key: "cardPage",
                                                tab: "圖文顯示"
                                            },
                                            {
                                                key: "page",
                                                tab: "條列顯示"
                                            },

                                        ]}
                                        onChange={(val) => {
                                            setShowMode(val)
                                        }}>

                                    </Tabs>
                                </Col>
                                <Col span={24}>
                                    <ProTableOt
                                        searchParams={{
                                            ...tableSearchParams,
                                            ...selectedSearch
                                        }}
                                        showSearch={false}
                                        reloadButton={false}
                                        manageColumnsButton={false}
                                        rowKey={"bib_biblionumber"}
                                        actionRef={actionRef}
                                        columns={columns}
                                        check={check}
                                        setCheck={setCheck}
                                        request={async (params = {}, sort, filter) => {
                                            // setAxiosMethod("get")
                                            let newParams = {};
                                            let order = setOrders(sort);
                                            let defaultDate = {
                                                datecreated_start: '1900-01-01',
                                                datecreated_end: dayjs().endOf('year').format('YYYY-MM-DD'),
                                            }
                                            let newTableSearchParams = {
                                                ...tableSearchParams,
                                                ...selectedSearch
                                            }
                                            if (!tableSearchParams?.keyword) {
                                                newTableSearchParams = {
                                                    ...defaultDate
                                                }
                                            }
                                            newParams = {
                                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                                ...newParams,
                                                order,
                                                size: params.pageSize,
                                                cur_page: params.current,
                                                // custom_filter_value: params.keyword ?? "",
                                                // custom_filter_key: custom_filter_key,
                                                // ...tableSearchParams
                                                ...newTableSearchParams
                                            };
                                            newParams = setParamsFilter({
                                                ...newParams,
                                            });
                                            return bibController.getData({
                                                ...newParams,
                                            }).then((response) => {
                                                console.log({
                                                    response
                                                })
                                                setPostCoordinateSearching(response?.post_coordinate_searching)
                                                return {
                                                    ...response
                                                }
                                            });
                                        }}

                                        rowSelection={false}
                                        manage_columns={true}
                                        showMode={showMode} // page || infiniteScroll || card,
                                        cardRender={(record) => {
                                            return (
                                                <Card style={styles.cardStyle}>
                                                    <Row gutter={[16, 16]}>
                                                        <Col xxl={4} xl={4} lg={5} md={8} sm={10} xs={24}   >
                                                            <Row justify={"center"}>
                                                                <Col xxl={24} xl={24} lg={24} md={24} sm={16} xs={12} >
                                                                    <AspectRatio ratio={3 / 4}>
                                                                        <img
                                                                            src={"https://media.taaze.tw/showLargeImageByIsbn.ashx?height=100%&isbn=" +
                                                                                record?.bibitem_isbn} className=" h-full w-full rounded-md object-cover" />
                                                                    </AspectRatio>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col xxl={20} xl={20} lg={19} md={16} sm={14} xs={24}>
                                                            <Row gutter={[16, 16]}>
                                                                <Col span={24}>
                                                                    {getBibInfoFormat().map((val) => {
                                                                        if (val?.language_name === "bib_title") {
                                                                            return (
                                                                                <Typography.Title level={3}>
                                                                                    {val?.valueKeys.map((keysValue) => record?.[keysValue])}
                                                                                </Typography.Title>
                                                                            )
                                                                        }
                                                                        else if (val?.language_name === "Language") {
                                                                            return (
                                                                                <Col span={24}>
                                                                                    <Typography.P>{t(`${val?.language_name}`)}: {val?.valueKeys.map((keysValue) => record?.[keysValue]?.['Language'])} </Typography.P>
                                                                                </Col>
                                                                            )
                                                                        }
                                                                        else {
                                                                            return <Col span={24}>
                                                                                <Typography.P>{t(`${val?.language_name}`)}:
                                                                                    {val?.valueKeys.map((keysValue) => {
                                                                                        if (val?.isJoin) {
                                                                                            return record?.[keysValue]?.join('、')
                                                                                        }
                                                                                        else {
                                                                                            return record?.[keysValue]
                                                                                        }
                                                                                    })}
                                                                                </Typography.P>
                                                                            </Col>
                                                                        }

                                                                    })}
                                                                    <Col span={24}>
                                                                        <Typography.P>館藏量:
                                                                            {record?.items_count || 0}
                                                                        </Typography.P>
                                                                    </Col>
                                                                </Col>
                                                                <Col span={24} style={{ textAlign: 'right' }}>
                                                                    <Button
                                                                        // style={styles.informationButton}
                                                                        onClick={() => {
                                                                            window.open(`./collection_search/?biblionumber=${record?.bib_biblionumber}`, 'blank')
                                                                        }}
                                                                    >
                                                                        館藏資訊
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            )
                                        }}
                                        cardModeSetting={{
                                            columnsCount: 1,
                                            singleRowHeight: 100,
                                        }}
                                    />
                                </Col>
                            </Row>

                        </Col>
                    </Row>

                </Col>
            </Row>
        </div>
    );
}

export default SearchFunction;
